exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans:300,300i,400,400i,600,700);", ""]);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Oswald:300,400,600,700);", ""]);

// module
exports.push([module.id, "body{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased}.no-select{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.project-custom-tooltip{position:absolute;width:100px!important;height:150px!important;background-color:transparent;display:flex;flex-direction:column}.project-custom-tooltip .project-custom-tooltip-count{width:100%;margin-top:-5px;font-family:Open Sans,sans-serif;font-size:12px;color:#2c2c2c;text-align:center}.project-custom-tooltip .project-custom-tooltip-date{width:100%;margin-top:118px;font-family:Open Sans,sans-serif;font-size:12px;color:#2c2c2c;text-align:center}", ""]);

// exports
exports.locals = {
	"addGreen": "#4bb543",
	"inProgress": "#f5a623",
	"complete": "#5db348",
	"iconGrey": "#A4A4A4",
	"warmGreyTwo": "#9b9b9b",
	"gray": "#676767",
	"offBlack": "#2C2C2C",
	"lightElement": "#D8D8D8",
	"white": "#fff",
	"aoDarkBlue": "#184e78",
	"secondaryLabelFont": "#bababa",
	"nonExistant": "#9b9b9b",
	"red": "#D0011B"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/containers/ProjectsContainer/ProjectHierarchy/ProjectTimeline/CustomToolTip/CustomToolTip.scss
// module id = 1818
// module chunks = 0